import DataSource from "devextreme/data/data_source";
import ODataStore from "devextreme/data/odata/store";
import { filter } from "lodash";
import React from "react";
import { useQuery } from "react-query";
import { atom, useRecoilValue } from "recoil";
import { loadFn, Params } from "shared/component/dxf-map/dxf-map";
import { client } from "shared/helpers/client";



export const bookingFilterAtom = atom({
  key: "booking-filter",
  default: {
    filter:{"StartDate":{"operator":"Equals","value":"2020-01-02 11:07:42.807"},"EndDate":{"operator":"Equals","value":"2022-01-02 11:16:03.377"}}
  },
});



export const getMyBooking=(params: Params)=> {
  return client<any[]>('/OwnerBooking/getMyBooking', { params })
}


export const useBookingSource = (filter:any) => new DataSource({
              key: 'id',
              load: loadFn(p =>
                  client('/OwnerBooking/getMyBooking', {
                      params: {
                          ...p,
                          searchTerm:filter.filter
                      },
                  })
              ),
})
 
